<template>
  <div class="el-menu el-menu--horizontal el-menu--primary is-fixed-white el-menu--without-submenus pa-2">
    <div class="main">
      <template v-if="filters && filters.length">
        <div class="filter-wrapper" v-for="(filter, index) in filters" :key="index">
          <div class="el-text el-text--ellipsis filter-label pr-8" v-if="filter.item_label">{{filter.item_label}}:</div>
          <el-checkbox-group :value="selectedFilters[filter.filter_var] || []" @input="filterChange($event, index)">
            <el-checkbox-button
              v-for="values in filter.filter_values"
              :key="values.value"
              :label="values.value"
              >
              {{ values.label.toUpperCase() }}
            </el-checkbox-button>
          </el-checkbox-group>
        </div>
        <el-tooltip content="Sort By Date" placement="bottom">
          <el-button class="sort-by-date-btn top mr-8 ml-8" :class="{top: this.ordered === 'created_date', bottom: this.ordered === '-created_date'}" type="icon" @click="changeSortByDate" icon="i-arrow-left--32" size="med">
          </el-button>
        </el-tooltip>
      </template>
      <el-spinner color="white" v-else/>
    </div>
    <div class="aside">
      <span class="el-text car-numbers-label">{{carNumbersLabel}} {{newPhotosCount ? '/New: ' + newPhotosCount : ''}} </span>
      <el-button class="race-img-card-btn" size="small" type="ghost" @click="refresh">
        <el-icon name="i-refresh--32" size="md"/>
      </el-button>
      <el-tooltip content="Clear filters" placement="bottom">
        <el-button class="race-filters-clear-btn mr-8 ml-8" @click="clearFilters" :disabled="!Object.keys(this.selectedFilters).length">
          Clear Filters
        </el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { getRaceImages } from '../../api/raceimages'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RaceFilterHeader',
  props: {
    filters: {
      type: Array,
      required: true
    },
    selectedFilters: {
      type: Object,
      required: true
    },
    carNumbersLabel: {
      type: String,
      default: ''
    },
    totalCountImages: {
      type: Number,
      defoult: -1
    }
  },
  data() {
    return {
      newPhotosCount: 0,
      timeout: null,
    }
  },
  computed: {
    ...mapGetters ({
      ordered: 'race/getOrdered',
    }),
    raceId() {
      return this.$route.params.raceId
    },
  },
  methods: {
    ...mapActions({
      changeOrdered: 'race/changeOrdered'
    }),
    filterChange(value, filterTitle) {
      this.$emit('changeFiltersHandler', value, filterTitle, 'header_filters')
    },
    clearFilters() {
      this.$emit('clearFilters')
    },
    checkNewPhoto() {
      this.timeout = setTimeout(() => {
        return getRaceImages(this.raceId, {limit: 1, page: 1, order: '-created_date'})
          .then(res => {
            this.newPhotosCount = res.data.total - this.totalCountImages
            return this.checkNewPhoto()
          })
        },
        30000
      )
    },
    refresh() {
      this.$emit('refresh')
    },
    changeSortByDate() {
      this.changeOrdered(this.ordered === 'created_date' ? '-created_date' : 'created_date')
    }
  },
  mounted() {
    if (this.totalCountImages !== -1) {
      this.checkNewPhoto()
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  margin-right: 10px;
  align-items: center;
  ::v-deep {
    .el-checkbox-button {
      height: 32px;
      .el-checkbox-button__content {
        padding: 0 8px;
        .el-text.el-text--body-32 {
          line-height: 16px;
          font-size: 13px;
        }
      }
    }
  }
}

.filter-label {
  font-weight: bold;
  font-size: 14px;
}

.el-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main {
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.aside {
  display: flex;
  align-items: center;
}

.car-numbers-label {
  font-size: 16px;
  margin-right: 3px;
}

.sort-by-date-btn, .sort-by-date-btn *{
  padding: 0;
  margin: 0;
}

.sort-by-date-btn {
  ::v-deep {
    .el-button__icon {
      margin: 0;
    }
  }
}

.sort-by-date-btn.top {
  transform: rotate(90deg);
}
.sort-by-date-btn.bottom {
  transform: rotate(-90deg);
}
</style>
